import { Injectable } from '@angular/core';
import { RequestForm } from '@app/models/_index';
import { environment } from '@environments/environment';
import { ApiService } from './apiService.service';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private settings = {
    async: true,
    crossDomain: true,
    method: 'POST',
    headers: {},
  };

  constructor(private apiService: ApiService) {}

  /**
   * TODO: Currently not being used with dlp-email lambda. Will need to revisit.
   * Request a Quote Voucher quote from data to get firstName, lastName, email, phone, country and notes
   * @param data - form data needed for email notification lambda service, including course information
   * related to voucher request.
   * @returns - a Promise any object
   */
  public requestVoucher(requestFormData: RequestForm): Promise<Object> {
    return this.apiService.post(
      `${environment.register_url}`,
      JSON.stringify(requestFormData),
      this.settings
    );
  }
}
